import React, { useEffect, useState } from "react";
import "./FloatingUniqueButtons.css";
import { FaArrowUp, FaBriefcase, FaHome, FaWhatsapp } from "react-icons/fa";

export default function FloatingUniqueButtons() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="fub-wrapper">

     
      {/* <div className="fub-btn-wrapper">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSfTxBCT28U3D6_Fvz2GAKrNMzKMmIo-XLpcRN7goZm0j6df6g/viewform?usp=sharing" className="fub-btn fub-call">
          <FaBriefcase />
        </a>
        <span className="fub-tooltip">Hire / Careers</span>
      </div>

     
      <div className="fub-btn-wrapper">
        <a href="/contact" className="fub-btn fub-center">
          <FaHome />
        </a>
        <span className="fub-tooltip">Contact Center</span>
      </div> */}

       <div className="fub-btn-wrapper">
    <a 
      href="https://wa.me/919886855700" 
      target="_blank" 
      rel="noopener noreferrer"
      className="fub-btn fub-whatsapp"
    >
      <FaWhatsapp />
    </a>
    <span className="fub-tooltip">Chat on WhatsApp</span>
  </div>

      {/* --- Scroll to Top Button --- */}
      {showScrollTop && (
        <div className="fub-btn-wrapper">
          <button className="fub-btn fub-scroll" onClick={scrollToTop}>
            <FaArrowUp />
          </button>
          <span className="fub-tooltip">Scroll Top</span>
        </div>
      )}
    </div>
  );
}
